import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

/**
 * Firebase Web SDK config.
 *
 * These values are NOT secret — they're embedded in every Firebase web app
 * and appear in the browser bundle. Security is enforced by Firestore
 * rules + App Check, not by hiding this config.
 *
 * To get the real values:
 *   Firebase Console → Project Settings → General → Your apps →
 *   Web app (</> icon) → Config
 */
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ??
    "AIzaSyAbKfnsIXPZz55W6Cr83W2lGlm1DS35lAM",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ??
    "word-race-a7f04.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "word-race-a7f04",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ??
    "word-race-a7f04.firebasestorage.app",
  messagingSenderId:
    import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "390756279873",
  appId: import.meta.env.VITE_FIREBASE_APP_ID ??
    "1:390756279873:web:875be3fb30401e19f648c0",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "europe-west1");
